// extracted by mini-css-extract-plugin
export default {"indicatorDot":"syncStatusIndicator_indicatorDot__A1+oY","indicatorContainer":"syncStatusIndicator_indicatorContainer__GkOKH"};